__turbopack_context__.v({
  "className": "ubuntu_9d8db6bb-module__Kv6fWW__className",
});
